import M$plugin$ManageDera from 'C:/proyectos/managedera/src/facade/js/managedera';
import M$control$ManageDeraControl from 'C:/proyectos/managedera/src/facade/js/managederacontrol';
import M$impl$control$ManageDeraControl from 'C:/proyectos/managedera/src/impl/ol/js/managederacontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.ManageDera = M$plugin$ManageDera;
window.M.control.ManageDeraControl = M$control$ManageDeraControl;
window.M.impl.control.ManageDeraControl = M$impl$control$ManageDeraControl;
